import store from '@/state/store';
import { param } from 'jquery';

import { createRouter, createWebHistory } from "vue-router";
import { getCurrentUser } from 'vuefire';

const routes = [
  {
    path: "/",
    name: "Landingpage",
    meta: {
      title: "Wodhero | Gym & CrossFit Box Management Software",
      description: "Wodhero is the modern platform for gym and CrossFit box management. Handle members, class booking, payments via Stripe, and much more — free to get started.",
    },
    component: () => import("../views/landingpage/index.vue"),
  },
  {
    path: "/workouts",
    name: "WODHERO Workouts",
    component: () => import("../views/landingpage/workouts.vue"),
    meta: {
      title: "Workouts",
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to logged in version of all workouts
          next({ name: "/workouts/all" });
        } else {
          // Continue to the public workouts page
          next();
        }
      },
    },
  },
  {
    path: "/exercises",
    name: "WODHERO exercises",
    component: () => import("../views/landingpage/exercises.vue"),
    meta: {
      title: "Workouts",
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to logged in version of all exercises
          next({ name: "/exercises/all" });
        } else {
          // Continue to the public exercise page
          next();
        }
      },
    },
  },
  {
    path: "/gyms",
    name: "WODHERO gyms",
    component: () => import("../views/landingpage/gyms.vue"),
    meta: {
      title: "Gyms",
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to logged in version of all gyms
          next({ name: "/gyms/all" });
        } else {
          // Continue to the public gyms page
          next();
        }
      },
    },
  },
  {
    path: "/checkin/:id",
    name: "Check-in Fallback",
    component: () => import("../views/checkin/index.vue"),
    meta: {
      title: "Check In",
    },
  },
  {
    path: "/crossfit-box-software",
    name: "CrossFit Box Software",
    component: () => import("../views/landingpage/CrossfitBoxSoftware.vue"),
    meta: {
      title: "CrossFit Box Management Software",
    },
  },
  {
    path: "/free-gym-software",
    name: "Free Gym Software",
    component: () => import("../views/landingpage/FreeGymSoftware.vue"),
    meta: {
      title: "Free Gym Management Software",
    },
  },
  {
    path: "/whiteboard-tracking",
    name: "Whiteboard Tracking",
    component: () => import("../views/landingpage/WhiteboardTracking.vue"),
    meta: {
      title: "Digital Whiteboard for Your Fitness Center",
    },
  },
      {
    path: "/admin/musclegroups",
    name: "Muscle groups",
    meta: {
      title: "Muscle groups",
      isProtected: true,
    },
    component: () => import("../views/admin/musclegroups.vue"),

  },
  {
    path: "/admin/keywords",
    name: "Keywords",
    meta: {
      title: "Keywords management",
      isProtected: true,
    },
    component: () => import("../views/admin/KeywordsManager.vue"),

  },
  {
    path: "/admin/exercises",
    name: "Exercises",
    meta: {
      title: "Exercises",
      isProtected: true,
    },
    component: () => import("../views/admin/exercises.vue"),

  },
  {
    path: "/admin/ailogs",
    name: "AI Logs",
    meta: {
      title: "AI Logs",
      isProtected: true,
    },
    component: () => import("../views/admin/ailogs.vue"),

  },
  {
    path: "/admin/gyms",
    name: "Wodhero Gyms",
    meta: {
      title: "All Wodhero Gyms",
      isProtected: true,
    },
    component: () => import("../views/admin/gyms.vue"),

  },
  {
    path: "/admin/invites",
    name: "Admin Invites",
    meta: {
      title: "Admin Invites Management",
      isProtected: true,
    },
    component: () => import("../views/admin/invites.vue"),

  },
  {
    path: "/admin/users",
    name: "Admin Users",
    meta: {
      title: "Admin Users Management",
      isProtected: true,
    },
    component: () => import("../views/admin/users.vue"),

  },
  {
    path: "/admin/seo",
    name: "SEO Management",
    meta: {
      title: "SEO Management & Sitemap",
      isProtected: true,
    },
    component: () => import("../views/admin/seo.vue"),

  },
  {
    path: "/admin/articles",
    name: "Admin Articles",
    meta: {
      title: "Articles",
      isProtected: true,
    },
    component: () => import("../views/admin/articles/index.vue"),
  },
  {
    path: "/admin/articles/new",
    name: "New Article",
    meta: {
      title: "New Article",
      isProtected: true,
    },
    component: () => import("../views/admin/articles/editor.vue"),
  },
  {
    path: "/admin/articles/:id/edit",
    name: "Edit Article",
    meta: {
      title: "Edit Article",
      isProtected: true,
    },
    component: () => import("../views/admin/articles/editor.vue"),
  },
  {
    path: "/admin/articles/categories",
    name: "Article Categories",
    meta: {
      title: "Article Categories",
      isProtected: true,
    },
    component: () => import("../views/admin/articles/categories.vue"),
  },
  {
    path: "/admin/landing-pages",
    name: "Admin Landing Pages",
    meta: {
      title: "Landing Pages",
      isProtected: true,
    },
    component: () => import("../views/admin/landing-pages/index.vue"),
  },
  {
    path: "/admin/customer-migration",
    name: "Customer Migration",
    meta: {
      title: "Customer Migration | Site Admin",
      isProtected: true,
    },
    component: () => import("../views/admin/customer-migration.vue"),
  },
  {
    path: "/admin/landing-pages/new",
    name: "New Landing Page",
    meta: {
      title: "New Landing Page",
      isProtected: true,
    },
    component: () => import("../views/admin/landing-pages/editor.vue"),
  },
  {
    path: "/admin/landing-pages/:id/edit",
    name: "Edit Landing Page",
    meta: {
      title: "Edit Landing Page",
      isProtected: true,
    },
    component: () => import("../views/admin/landing-pages/editor.vue"),
  },
  {
    path: "/articles",
    name: "Articles",
    meta: {
      title: "Articles & Guides | Wodhero",
    },
    component: () => import("../views/articles/index.vue"),
  },
  {
    path: "/articles/:slug",
    name: "Article",
    meta: {
      title: "Article | Wodhero",
    },
    component: () => import("../views/articles/show.vue"),
  },
  {
    path: "/article/all",
    name: "App Articles",
    meta: {
      title: "Articles & Guides | Wodhero",
      isProtected: true,
    },
    component: () => import("../views/article/all.vue"),
  },
  {
    path: "/article/:slug",
    name: "App Article Show",
    meta: {
      title: "Article | Wodhero",
      isProtected: true,
    },
    component: () => import("../views/article/show.vue"),
  },
  {
    path: "/app/articles",
    name: "App Articles Alias",
    meta: {
      title: "Articles & Guides | Wodhero",
      isProtected: true,
    },
    component: () => import("../views/article/all.vue"),
  },
  {
    path: "/app/articles/:slug",
    name: "App Article Show Alias",
    meta: {
      title: "Article | Wodhero",
      isProtected: true,
    },
    component: () => import("../views/article/show.vue"),
  },
  {
    path: "/exercise/add",
    name: "Add exercise",
    meta: {
      title: "Add exercise",
      isProtected: true,
    },
    component: () => import("../views/exercise/add.vue"),

  },
  {
    path: "/admin/scoretypes",
    name: "WOD types",
    meta: {
      title: "WOD types",
      isProtected: true,
    },
    component: () => import("../views/admin/scoretypes.vue"),

  },
  {
    path: "/admin/wodcategories",
    name: "WOD categories",
    meta: {
      title: "WOD Categories",
      isProtected: true,
    },
    component: () => import("../views/admin/wodcategories.vue"),

  },
  {
    path: "/admin/workouts",
    name: "Workouts",
    meta: {
      title: "Workouts",
      isProtected: true,
    },
    component: () => import("../views/admin/workouts.vue"),

  },
  {
    path: "/admin/premium",
    name: "WODHERO PREMIUM",
    meta: {
      title: "Overview of Wodhero Premium users",
      isProtected: true,
    },
    component: () => import("../views/admin/premium.vue"),

  },
  {
    path: "/admin/mobile-app",
    name: "MOBILE APP MANAGEMENT",
    meta: {
      title: "Mobile App Management",
      isProtected: true,
    },
    component: () => import("../views/admin/mobile-app.vue"),
  },
  {
    path: "/admin/wrapped",
    redirect: "/admin/mobile-app",
  },
  {
    path: "/admin/content-reports",
    name: "Content Reports",
    meta: {
      title: "Content Reports & Moderation",
      isProtected: true,
    },
    component: () => import("../views/admin/content-reports.vue"),

  },
  {
    path: "/workout/add",
    name: "Add workout",
    meta: {
      title: "Add workout",
      isProtected: true,
    },
    component: () => import("../views/workout/add.vue"),

  },
  {
    path: "/workout/:id/edit",
    name: "Edit workout",
    meta: {
      title: "Edit workout",
      isProtected: true,
    },
    component: () => import("../views/workout/edit.vue"),

  },
  {
    path: "/workout/log/:id",
    name: "Log workout",
    meta: {
      title: "Log a workout",
      isProtected: true,
    },
    component: () => import("../views/workout/log.vue"),
  },
  {
    path: "/workout/log/picture/:id",
    name: "Log workout from picture",
    meta: {
      title: "Log a workout from picture",
      isProtected: true,
    },
    component: () => import("../views/workout/logPicture.vue"),
  },
  {
    path: "/gym/:gymid/class/:classid/instance/:instanceid/log",
    name: "Log class workout",
    meta: {
      title: "Log a classworkout",
      isProtected: true,
    },
    component: () => import("../views/class/log.vue"),
  },
  {
    path: "/exercise/log/:id",
    name: "Log exercise",
    meta: {
      title: "Log an exercise",
      isProtected: true,
    },
    component: () => import("../views/exercise/log.vue"),
  },
  {
    //Add displayName and email to the path
    path: "/signin",
    name: "signin",
    component: () => import("../views/account/signin.vue"),
    meta: {
      title: "Login",
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "default" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/register",
    name: "register",
    component: () => import("../views/account/signup.vue"),
    meta: {
      title: "Register",
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "default" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/home",
    name: "app",
    meta: {
      title: "Wodhero",
      isProtected: true,
    },
    component: () => import("../views/dashboard/index.vue"),

  },
  {
    path: "/athlete-analytics",
    name: "athlete-analytics",
    meta: {
      title: "Athlete Analytics",
      isProtected: true,
    },
    component: () => import("../views/athlete-analytics/index.vue"),
  },
  {
    path: "/athlete-analytics/enhanced",
    name: "athlete-analytics-enhanced",
    meta: {
      title: "Enhanced Athlete Analytics",
      isProtected: true,
    },
    component: () => import("../views/athlete-analytics/enhanced.vue"),
  },
  {
    path: "/premium/nutrition",
    name: "premium-nutrition",
    meta: {
      title: "Nutrition Tracker",
      isProtected: true,
    },
    component: () => import("../views/premium/nutrition.vue"),
  },
  {
    path: "/workout/all",
    name: "All workouts",
    meta: {
      title: "All workouts",
      isProtected: true,
    },
    component: () => import("../views/workout/all.vue"),
  },
  {
    path: "/workout/public/:id",
    name: "Workout public",
    meta: {
      title: "Workout",
    },
    component: () => import("../views/landingpage/showWorkout.vue"),
  },
  {
    path: "/workout/:id",
    name: "Workout",
    meta: {
      title: "Workout",
      isProtected: true,
    },
    component: () => import("../views/workout/show/index.vue"),
  },
  {
    path: "/exercise/all",
    name: "All exercises",
    meta: {
      title: "All exercises",
      isProtected: true,
    },
    component: () => import("../views/exercise/all.vue"),

  },
  {
    path: "/exercise/:id",
    name: "Exercise",
    meta: {
      title: "Exercise",
      isProtected: true,
    },
    component: () => import("../views/exercise/show/index.vue"),

  },
  {
    path: "/exercise/public/:id",
    name: "Exercise public",
    meta: {
      title: "Exercise",
    },
    component: () => import("../views/landingpage/showExercise.vue"),

  },
  {
    path: "/gym/create",
    name: "Create gym",
    meta: {
      title: "Create new gym",
      isProtected: true,
    },
    component: () => import("../views/gym/create.vue"),

  },
  {
    path: "/gym/all",
    name: "All gyms",
    meta: {
      title: "All gyms",
      isProtected: true,
    },
    component: () => import("../views/gym/all.vue"),

  },
  {
    path: "/gym/:id/memberships",
    name: "Gym memberships",
    meta: {
      title: "Gym memberships overview",
      isProtected: true,
    },
    component: () => import("../views/gym/memberships.vue"),

  },
  {
    path: "/gym/public/:id/memberships",
    name: "Gym memberships public",
    meta: {
      title: "Gym memberships overview",
    },
    component: () => import("../views/landingpage/showGym.vue"),

  },
  {
    path: "/gym/:id/admin",
    name: "Gym administration",
    meta: {
      title: "Gym Adminstration",
      isProtected: true,
    },
    component: () => import("../views/gym/admin/products.vue"),

  },
  {
    path: "/gym/:id/admin/dashboard",
    name: "Gym owner dashboard",
    meta: {
      title: "Gym Owner Dashboard",
      isProtected: true,
    },
    component: () => import("../views/gym/admin/dashboard.vue"),

  },
  {
    path: "/gym/:id/admin/onboarding",
    name: "Gym onboard members",
    meta: {
      title: "Gym Onboard new members",
      isProtected: true,
    },
    component: () => import("../views/gym/admin/onboarding.vue"),

  },
  {
    path: "/gym/:id/admin/settings/apiaccess",
    name: "Gym API Access",
    meta: {
      title: "API Access",
      isProtected: true,
    },
    component: () => import("../views/gym/admin/settings/apiaccess.vue"),

  },
  {
    path: "/gym/:id/admin/settings/memberregistration",
    name: "Gym Member Registration",
    meta: {
      title: "Member Registration",
      isProtected: true,
    },
    component: () => import("../views/gym/admin/settings/memberregistration.vue"),

  },
  {
    path: "/gym/:id/admin/settings/email-templates",
    name: "Gym Email Templates",
    meta: {
      title: "Email Templates",
      isProtected: true,
    },
    component: () => import("../views/gym/admin/settings/emailtemplates.vue"),

  },

  {
    path: "/gym/:id",
    name: "Gym",
    meta: {
      title: "Gym",
      isProtected: true,
    },
    component: () => import("../views/gym/show.vue"),

  },
  {
    path: "/gym/:id/admin/products",
    name: "Gym product administration",
    meta: {
      title: "Gym product Adminstration",
      isProtected: true,
    },
    component: () => import("../views/gym/admin/products.vue"),

  },
  {
    path: "/gym/:id/admin/settings/stripe",
    name: "Gym stripe administration",
    meta: {
      title: "Gym stripe Adminstration",
      isProtected: true,
    },
    component: () => import("../views/gym/admin/settings/stripe.vue"),

  },
  {
    path: "/gym/:id/admin/autocheckin",
    name: "Gym auto check-in settings",
    meta: {
      title: "Auto Check-In Settings",
      isProtected: true,
    },
    component: () => import("../views/gym/admin/autocheckin.vue"),

  },
  {
    path: "/gym/:id/admin/settings/doorAccess",
    name: "Gym door access settings",
    meta: {
      title: "Door Access Settings",
      isProtected: true,
    },
    component: () => import("../views/gym/admin/settings/doorAccess.vue"),

  },
  {
    path: "/gym/:id/admin/doorAccessLogs",
    name: "Gym door access logs",
    meta: {
      title: "Door Access Logs",
      isProtected: true,
    },
    component: () => import("../views/gym/admin/doorAccessLogs.vue"),

  },
  {
    path: "/gym/:id/admin/pricing",
    name: "Gym pricing administration",
    meta: {
      title: "Gym pricing Adminstration",
      isProtected: true,
    },
    component: () => import("../views/gym/admin/pricing.vue"),

  },
  {
    path: "/gym/:id/admin/employees",
    name: "Gym employees administration",
    meta: {
      title: "Gym employees Adminstration",
      isProtected: true,
    },
    component: () => import("../views/gym/admin/employees.vue"),
  },
  {
    path: "/gym/:id/admin/product/add",
    name: "Add new product",
    meta: {
      title: "Add new product",
      isProtected: true,
    },
    component: () => import("../views/gym/admin/addProduct.vue"),

  },
  {
    path: "/gym/:id/admin/product/:productId/edit",
    name: "Edit product",
    meta: {
      title: "Edit product",
      isProtected: true,
    },
    component: () => import("../views/gym/admin/editProduct.vue"),
  },
  {
    path: "/gym/:id/admin/subscriptions",
    name: "Gym subscriptions overview",
    meta: {
      title: "Gym subscriptions",
      isProtected: true,
    },
    component: () => import("../views/gym/admin/subscriptions.vue"),

  },
  {
    path: "/gym/:id/admin/subscriptions/:subscriptionid",
    name: "Gym subscription details",
    meta: {
      title: "Gym subscription",
      isProtected: true,
    },
    component: () => import("../views/gym/admin/showSubscription.vue"),

  },
  {
    path: "/gym/:id/admin/memberships",
    name: "Gym members overview",
    meta: {
      title: "Gym members",
      isProtected: true,
    },
    component: () => import("../views/gym/admin/members.vue"),

  },
  {
    path: "/gym/:id/admin/memberships/:memberid",
    name: "Gym member details",
    meta: {
      title: "Gym member",
      isProtected: true,
    },
    component: () => import("../views/gym/admin/showMember.vue"),

  },
  {
    path: "/gym/:id/admin/finance",
    name: "Gym financial overview",
    meta: {
      title: "Gym finance",
      isProtected: true,
    },
    component: () => import("../views/gym/admin/finance.vue"),

  },
  {
    path: "/gym/:id/admin/invoices/:invoiceid",
    name: "Gym invoice details",
    meta: {
      title: "Gym invoice",
      isProtected: true,
    },
    component: () => import("../views/gym/admin/showInvoice.vue"),

  },
  {
    path: "/gym/:id/admin/member/:memberid/invoices/create",
    name: "Create manual invoice",
    meta: {
      title: "Gym Create manuel invoice for gym member",
      isProtected: true,
    },
    component: () => import("../views/gym/admin/createInvoice.vue"),

  },
  {
    path: "/gym/:id/admin/workplan",
    name: "Gym Workplan",
    meta: {
      title: "Workplan",
      isProtected: true,
    },
    component: () => import("../views/gym/admin/workplan.vue"),
  },
  {
    path: "/gym/:id/admin/classes",
    name: "Gym Classes & events overview",
    meta: {
      title: "Gym Classes & events",
      isProtected: true,
    },
    component: () => import("../views/gym/admin/classes.vue"),

  },
  {
    path: "/gym/:id/employee/classes",
    name: "Employee Classes & events overview",
    meta: {
      title: "Employee Classes & events",
      isProtected: true,
    },
    component: () => import("../views/gym/employee/classes.vue"),

  },
  {
    path: "/gym/:id/employee/class/add",
    name: "Employee add class",
    meta: {
      title: "Employee Classes & events",
      isProtected: true,
    },
    component: () => import("../views/gym/employee/addClass.vue"),

  },
  {
    path: "/gym/:id/employee/class/:classid",
    name: "Employee class details",
    meta: {
      title: "Edit gym class or event details",
      isProtected: true,
    },
    component: () => import("../views/gym/employee/editClass.vue"),

  },
  {
    path: "/gym/:id/admin/class/:classid",
    name: "Gym class details",
    meta: {
      title: "Edit gym class or event details",
      isProtected: true,
    },
    component: () => import("../views/gym/admin/editClass.vue"),

  },
  {
    path: "/gym/:id/class/:classid/instance/:instanceid", //Show a specific instance of a class
    name: "Class overview",
    meta: {
      title: "Gym class details",
      isProtected: true,
    },
    component: () => import("../views/class/show.vue"),

  },
  {
    path: "/gym/:id/class/:classid/instance/:instanceid/program", //Program an instance of a class
    name: "Class programming",
    meta: {
      title: "Program a class",
      isProtected: true,
    },
    component: () => import("../views/class/program.vue"),

  },
  {
    path: "/gym/:id/admin/class/add",
    name: "Add new class or event",
    meta: {
      title: "Add new class or event",
      isProtected: true,
    },
    component: () => import("../views/gym/admin/addClass.vue"),

  },
  {
    path: "/gym/:id/admin/coupons",
    name: "Gym Coupons & credits overview",
    meta: {
      title: "Gym discounts",
      isProtected: true,
    },
    component: () => import("../views/gym/admin/coupons.vue"),

  },
  {
    path: "/gym/:id/admin/coupons/:stripeCouponID",
    name: "Gym Coupon overview",
    meta: {
      title: "Gym Coupon",
      isProtected: true,
    },
    component: () => import("../views/gym/admin/showCoupon.vue"),

  },
    {
    path: "/gym/:id/admin/coupons/:stripeCouponID",
    name: "Gym Coupon overview",
    meta: {
      title: "Gym Coupon",
      isProtected: true,
    },
    component: () => import("../views/gym/admin/showCoupon.vue"),

  },
  {
    path: "/gym/:id/admin/displays",
    name: "Gym displays management",
    meta: {
      title: "Gym Displays",
      isProtected: true,
    },
    component: () => import("../views/gym/admin/displays.vue"),

  },
  {
    path: "/gym/:id/admin/leads",
    name: "Gym leads management",
    meta: {
      title: "Gym Leads",
      isProtected: true,
    },
    component: () => import("../views/gym/admin/leads.vue"),

  },
  {
    path: "/gym/:id/buy",
    name: "Buy gym membership",
    meta: {
      title: "Buy gym membership",
      isProtected: true,
    },
    component: () => import("../views/gym/buy.vue"),
  },
  {
    path: "/gym/buy/product/:id",
    name: "Buy product",
    meta: {
      title: "Buy a new product",
      isProtected: true,
      requiresAuth: true,
    },
    component: () => import("../views/gym/buy.vue"),
    beforeResolve(routeTo, routeFrom, next) {
      // Store the intended destination for redirect after signup
      const intendedRoute = routeTo.fullPath;
      localStorage.setItem('intendedDestination', intendedRoute);
      
      // If the user is already logged in, continue to the product
      if (store.getters["auth/loggedIn"]) {
        next();
      } else {
        // Redirect to signup with return URL
        next({
          name: "register",
          query: { redirect: intendedRoute }
        });
      }
    },
  },
    {
    path: "/profile/:id",
    name: "Profile",
    meta: {
      title: "Profile",
      isProtected: true,
    },
    component: () => import("../views/account/profile.vue"),

  },
  {
    path: "/profile/settings",
    name: "Profile settings",
    meta: {
      title: "Profile settings",
      isProtected: true,
    },
    component: () => import("../views/account/settings.vue"),
  },
  {
    path: "/profile/support",
    name: "Contact support",
    meta: {
      title: "Profile support information",
      isProtected: true,
    },
    component: () => import("../views/account/support.vue"),
  },
  {
    path: "/profile/calculator",
    name: "Wodhero Calculator",
    meta: {
      title: "Wodhero calculator",
      isProtected: true,
    },
    component: () => import("../views/account/calculator.vue"),

  },
  {
    path: "/profile/invoices",
    name: "User invoices",
    meta: {
      title: "User invoices overview",
      isProtected: true,
    },
    component: () => import("../views/account/invoices.vue"),

  },
  {
    path: "/profile/subscriptions",
    name: "User subscriptions",
    meta: {
      title: "User subscriptions overview",
      isProtected: true,
    },
    component: () => import("../views/account/subscriptions.vue"),

  },
  {
    path: "/profile/invoices/:id",
    name: "User invoice details",
    meta: {
      title: "User invoice details overview",
      isProtected: true,
    },
    component: () => import("../views/account/showInvoice.vue"),

  },
  {
    path: "/profile/premium/subscribe",
    name: "Wodhero Premium",
    meta: {
      title: "Subscripe to Wodhero Premium",
      isProtected: true,
    },
    component: () => import("../views/account/buypremium.vue"),
  },
  {
    path: "/profile/:id/logbook",
    name: "Logbook",
    meta: {
      title: "Your wodhero logbook",
      isProtected: true,
    },
    component: () => import("../views/account/logbook.vue"),
  },
  {
    path: "/profile/history",
    name: "History",
    meta: {
      title: "Your wodhero training history",
      isProtected: true,
    },
    component: () => import("../views/account/history.vue"),
  },
  {
    path: "/profile/myworkouts",
    name: "My Workouts",
    meta: {
      title: "My Workouts",
      isProtected: true,
    },
    component: () => import("../views/account/myworkouts.vue"),
  },
  {
    path: "/aboutUs",
    name: "About Us",
    meta: {
      title: "About Us",
    },
    component: () => import("../views/landingpage/aboutUs.vue"),
  },
  {
    path: "/security-privacy",
    name: "Security & Privacy",
    meta: {
      title: "Security & Privacy Policy",
    },
    component: () => import("../views/security-privacy.vue"),
  },
  {
    path: "/terms-conditions",
    name: "Terms & Conditions",
    meta: {
      title: "Terms & Conditions",
    },
    component: () => import("../views/terms-conditions.vue"),
  },
  {
    path: "/500",
    name: "500",
    meta: {
      title: "500",
    },
    component: () => import("../views/500.vue"),
  },
  //Create af 404 route that catches all routes that are not defined
  {
    path: "/:pathMatch(.*)*",
    name: "404",
    meta: {
      title: "404",
    },
    component: () => import("../views/404.vue"),
  },
  {
    path: "/display",
    name: "Display Client",
    meta: {
      title: "Display Client",
      isProtected: false, // Display doesn't need user authentication
    },
    component: () => import("../views/display/index.vue"),
  },
];

const router = createRouter({
  history: createWebHistory('/'),
  routes,
});

async function authGuard(to) {
  // Ensures the user is initialized 
  const user = await getCurrentUser()
  if(to.meta.isProtected && !user) {
    // If an unauthenticated user or search crawler visits a workout or exercise detail page,
    // redirect them to the corresponding public page instead of the login screen.
    if (to.name === 'Workout' && to.params.id) {
      return {
        path: `/workout/public/${to.params.id}`,
        query: to.query
      };
    }
    if (to.name === 'Exercise' && to.params.id) {
      return {
        path: `/exercise/public/${to.params.id}`,
        query: to.query
      };
    }

    // Redirect to login with the intended destination as a query parameter
    return {
      path: '/signin',
      query: { redirect: to.fullPath }
    };
  }
}

router.beforeEach(authGuard);

export default router;